import {Signal, InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

export interface INotificationItem {
  id: Signal<string>;
  title: Signal<string>;
  description: Signal<string>;
  timestamp: Signal<string>;
  handleClick(): void | Promise<void> | Observable<void>;
}

export const NOTIFICATION_ITEM_TOKEN = new InjectionToken<INotificationItem>('NOTIFICATION_ITEM_TOKEN');
